export const MENTOR_CLASS_ROUTE_NAMES = {
  MAIN: "classroomMentorClass",
  STUDENTS: "classroomMentorClassStudents",
  STUDENT_RATINGS: "classroomMentorClassStudentRatings",
  ADVISORY_RATINGS: "classroomMentorClassAdvisoryRatings",
  GROUP_RATINGS: "classroomMentorClassGroupRatings",
  PORTFOLIO: "classroomMentorClassPortfolio",
  TASKS: "classroomMentorClassTasks",
  LEARNING_GOALS: "classroomMentorClassLearningGoals",
  ACTIONPLANS: "classroomMentorClassActionplans",
  CONVERSATIONS: "classroomMentorClassConversations",
} as const;

export type MentorClassRouteNames =
  (typeof MENTOR_CLASS_ROUTE_NAMES)[keyof typeof MENTOR_CLASS_ROUTE_NAMES];

export const LESSON_CLASS_ROUTE_NAMES = {
  MAIN: "classroomLessonClass",
  STUDENTS: "classroomLessonClassStudents",
  STUDENT_RATINGS: "classroomLessonClassStudentRatings",
  ADVISORY_RATINGS: "classroomLessonClassAdvisoryRatings",
  GROUP_RATINGS: "classroomLessonClassGroupRatings",
  PORTFOLIO: "classroomLessonClassPortfolio",
  TASKS: "classroomLessonClassTasks",
  LEARNING_GOALS: "classroomLessonClassLearningGoals",
  ACTIONPLANS: "classroomLessonClassActionplans",
  CONVERSATIONS: "classroomLessonClassConversations",
} as const;

export type LessonClassRouteNames =
  (typeof LESSON_CLASS_ROUTE_NAMES)[keyof typeof LESSON_CLASS_ROUTE_NAMES];
